import React from 'react';

import {  Card } from '@ergeon/core-components';

const DragHandle: React.FC = () => (
  <Card
    className="top-5 -right-0.5 z-50 relative flex justify-end items-center gap-2 px-2 py-1 w-full cursor-grab active:cursor-grabbing"
    data-drag-handle="true"
    flavor="transparent"
    zIndex={4}>
    <div className="flex gap-0.5">
      <div className="flex flex-col gap-0.5">
        <div className="bg-gray-300 dark:bg-gray-700 rounded-full size-0.5" />
        <div className="bg-gray-300 dark:bg-gray-700 rounded-full size-0.5" />
        <div className="bg-gray-300 dark:bg-gray-700 rounded-full size-0.5" />
      </div>
      <div className="flex flex-col gap-0.5">
        <div className="bg-gray-300 dark:bg-gray-700 rounded-full size-0.5" />
        <div className="bg-gray-300 dark:bg-gray-700 rounded-full size-0.5" />
        <div className="bg-gray-300 dark:bg-gray-700 rounded-full size-0.5" />
      </div>
    </div>
  </Card>
);

export default DragHandle;
